import React from 'react'
import { useSnackbar } from 'notistack'

import SubmitContact from '../../services/network/Requests/SubmitContact'
import cleanup from '../../helpers/cleanup'

const useContactForm = (type, source = 'rasti.ca', simple = false) => {
    const { enqueueSnackbar: snackbar } = useSnackbar()

    if (simple) {
        return async (values) => {
            const { success } = await SubmitContact(
                cleanup({ ...values, source, type })
            )
            return success
        }
    }

    return async (values, { setSubmitting }) => {
        setSubmitting(true)

        const { success } = await SubmitContact(
            cleanup({ ...values, source, type })
        )

        if (success) {
            snackbar('Your message has been successfully sent.', {
                variant: 'success',
            })
        } else {
            snackbar(
                'Unfortunately your message has not been sent! Please try again.',
                { variant: 'error' }
            )
        }

        setSubmitting(false)
    }
}

export default useContactForm
